import React, { useState, createContext, useEffect } from 'react'
import PropTypes from 'prop-types'

export const RouterContext = createContext({})

export const RouterContextProvider = ({ children }) => {
  const [showIframe, setShowIframe] = useState(false)
  const [iframeSrc, setIframeSrc] = useState('')
  const [iframeReady, setIframeReady] = useState(false)

  useEffect(() => {
    setIframeReady(false)
  }, [iframeSrc])

  const value = {
    showIframe,
    setShowIframe,
    iframeSrc,
    setIframeSrc,
    iframeReady,
    setIframeReady,
  }

  return (
    <RouterContext.Provider value={value}>{children}</RouterContext.Provider>
  )
}

RouterContextProvider.propTypes = {
  children: PropTypes.any,
}
